import React from 'react';
import { useReveal } from '../lib/useReveal';
const TIERS = [{
  id: 'base',
  badge: null,
  title: 'MegaPack Integral',
  tagline: 'Aprendé Biodescodificación',
  price: '$19.990',
  includes: ['6 tomos completos', '6 recursos prácticos', 'Casos clínicos reales', 'Protocolos completos', 'Certificado digital', 'Acceso inmediato'],
  cta: 'Quiero el MegaPack',
  href: 'https://academiaholisticaargentina.com/cart/48895855722746:1',
  accent: 'green'
}, {
  id: 'premium',
  badge: 'MÁS ELEGIDO',
  title: 'Premium',
  tagline: 'Aprendé + Consultá',
  price: '$27.990',
  includes: ['Todo lo del MegaPack Integral', 'Vademécum Interactivo', 'Herramienta rápida de consulta', 'Material complementario'],
  cta: 'Quiero el Premium',
  href: 'https://academiaholisticaargentina.com/cart/48895910347002:1',
  accent: 'gold'
}, {
  id: 'profesional',
  badge: 'EXPERIENCIA COMPLETA',
  title: 'Profesional',
  tagline: 'Aprendé + Consultá + Aplicá',
  price: '$34.990',
  includes: ['Todo lo del Premium', 'Vademécum Interactivo', 'Sistema Profesional de Consulta', 'Recursos avanzados para sesiones'],
  cta: 'Quiero el Profesional',
  href: 'https://academiaholisticaargentina.com/cart/48943422144762:1',
  accent: 'dark'
}];
type Tier = (typeof TIERS)[number];
function TierCard({
  tier,
  index
}: {
  tier: Tier;
  index: number;
}) {
  const [ref, vis] = useReveal();
  const isGold = tier.accent === 'gold';
  const isDark = tier.accent === 'dark';
  const cardBg = isGold ? 'bg-[#faf3e3]' : isDark ? 'bg-[#2d3f2a]' : 'bg-[#f5efe0]';
  const cardBorder = isGold ? 'border-2 border-[#b8860b]/50' : isDark ? 'border-2 border-[#1e3a1e]' : 'border border-[#2d3f2a]/15';
  const shadowClass = isGold ? 'shadow-md' : isDark ? 'shadow-lg' : 'shadow-sm';
  const titleColor = isDark ? 'text-[#faf3e3]' : 'text-[#1e3a1e]';
  const taglineColor = isDark ? 'text-[#eab308]' : 'text-[#5a6b3f]';
  const includesLabelColor = isDark ? 'text-[#ede4d0]/70' : 'text-[#5a6b3f]';
  const itemTextColor = isDark ? 'text-[#faf3e3]' : 'text-[#2a1f0f]';
  const checkColor = isGold ? 'text-[#b8860b]' : isDark ? 'text-[#eab308]' : 'text-[#5a6b3f]';
  const priceColor = isDark ? 'text-[#faf3e3]' : 'text-[#1e3a1e]';
  const arsColor = isDark ? 'text-[#ede4d0]/80' : 'text-[#5a5040]';
  const dividerColor = isGold ? 'border-[#b8860b]/15' : isDark ? 'border-[#faf3e3]/15' : 'border-[#2d3f2a]/10';
  const buttonClass = isGold ? 'bg-[#eab308] hover:bg-[#d4a017] text-[#0f0f1a] shadow-[0_8px_20px_rgba(184,134,11,0.3)] hover:shadow-[0_12px_25px_rgba(184,134,11,0.4)]' : isDark ? 'bg-[#eab308] hover:bg-[#d4a017] text-[#0f0f1a] shadow-[0_8px_20px_rgba(184,134,11,0.3)]' : 'bg-[#2d3f2a] hover:bg-[#1e3a1e] text-white shadow-md hover:shadow-lg';
  const badgeBg = isGold ? 'bg-[#b8860b]' : isDark ? 'bg-[#eab308] text-[#0f0f1a]' : '';
  return <div ref={ref} id={tier.id} className={`reveal relative ${cardBg} ${cardBorder} ${shadowClass} rounded-2xl p-4 md:p-6 flex flex-col scroll-mt-[180px] md:scroll-mt-8 ${vis ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 80}ms`
  }} data-id="element-243">
      {tier.badge && <div className={`absolute -top-3 left-1/2 -translate-x-1/2 ${badgeBg} ${isDark ? '' : 'text-white'} text-[10px] font-bold tracking-[0.2em] px-4 py-1.5 rounded-full whitespace-nowrap shadow-sm`} data-id="element-244">
          {tier.badge}
        </div>}

      <h3 className={`text-base md:text-xl font-serif font-bold ${titleColor} mb-0.5 leading-tight mt-1`} data-id="element-245">
        {tier.title}
      </h3>
      <p className={`${taglineColor} text-[11px] sm:text-sm font-semibold mb-2.5 md:mb-4`} data-id="element-246">
        {tier.tagline}
      </p>

      <p className={`${includesLabelColor} text-[9px] md:text-[10px] font-bold uppercase tracking-[0.2em] mb-2`} data-id="element-247">
        Incluye:
      </p>

      <ul className="space-y-1 md:space-y-1.5 mb-3 md:mb-4 flex-grow" data-id="element-248">
        {tier.includes.map((item, i) => <li key={i} className="flex items-start gap-1.5 md:gap-2" data-id="element-249">
            <span className={`${checkColor} flex-shrink-0 mt-0.5 font-bold text-[11px] md:text-xs`} data-id="element-250">
              ✓
            </span>
            <span className={`${itemTextColor} text-[12px] md:text-[13px] leading-snug font-medium`} data-id="element-251">
              {item}
            </span>
          </li>)}
      </ul>

      <div className={`text-center mb-3 md:mb-4 pt-2.5 md:pt-3 border-t ${dividerColor}`} data-id="element-252">
        <div className="flex items-baseline gap-1.5 justify-center" data-id="element-253">
          <span className={`text-xl md:text-3xl font-extrabold ${priceColor} leading-none`} data-id="element-254">
            {tier.price}
          </span>
          <span className={`${arsColor} text-xs md:text-sm font-semibold`} data-id="element-255">
            ARS
          </span>
        </div>
      </div>

      <a href={tier.href} target="_blank" rel="noopener noreferrer" className={`w-full block py-2.5 md:py-3 rounded-xl font-bold text-[11px] md:text-sm tracking-widest uppercase text-center transition-all hover:-translate-y-1 ${buttonClass}`} style={{
      fontFamily: "'Inter', sans-serif"
    }} data-id="element-256">
        {tier.cta} →
      </a>
    </div>;
}
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  return <section id="pricing" className="bg-[#f5efe0] py-5 md:py-10 px-4 sm:px-6 border-t border-[#2d3f2a]/5" style={{
    scrollMarginTop: '20px'
  }} data-id="element-257">
      <div className="container mx-auto max-w-6xl" data-id="element-258">
        <div ref={ref1} className={`reveal text-center mb-5 md:mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-259">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold leading-tight text-[#1e3a1e] mb-2" data-id="element-260">
            Elegí la versión que{' '}
            <span className="text-[#b8860b] italic" data-id="element-261">mejor se adapte</span> a vos
          </h2>
          <p className="text-[#3a4a35] text-sm md:text-base max-w-2xl mx-auto leading-relaxed" data-id="element-262">
            Todas las opciones incluyen acceso inmediato y certificado digital.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3.5 md:gap-6 items-stretch" data-id="element-263">
          {TIERS.map((tier, i) => <TierCard key={tier.id} tier={tier} index={i} data-id="element-264" />)}
        </div>
      </div>
    </section>;
}